import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyD9wW2CmgvqRtNUsDgQKWH-7PN1fG1WE0M",
  authDomain: "minimessenger-2b752.firebaseapp.com",
  projectId: "minimessenger-2b752",
  storageBucket: "minimessenger-2b752.appspot.com",
  messagingSenderId: "1017261062474",
  appId: "1:1017261062474:web:exampleappid"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);

export { auth, db };